import { getCornKernels, isCorn } from '@eigtech/shared-corn';
export const ensureClaimV2Corn = (claimNumber) => isCorn(claimNumber) ? claimNumber : makeClaimV2Corn(claimNumber);
export const makeClaimV2Corn = (resourceId) => `corn:claims:claim:${resourceId}`;
export const isClaimV2Corn = (entityId) => {
    if (!isCorn(entityId))
        return false;
    const { serviceName, resourceType } = getCornKernels(entityId);
    return serviceName === 'claims' && resourceType === 'claim';
};
